import { useEffect } from "react"

import { useAppDispatch } from "shared/config/store"
import styled from "styled-components"
import { AiMessageWriter } from "features/ai-assistant/ui/AiMessageWriter"
import { stopPollingThunk } from "features/ai-assistant/model/slice/aiAssistantSlice"
import { useTranslation } from "react-i18next"

export const AiAssistantNewChatPage = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  useEffect(() => {
    dispatch(stopPollingThunk())
  }, [dispatch])

  return (
    <SPageWrapper>
      <SDescription>
        {t("l_assistant_mainTitle")}
      </SDescription>

      <SMessageWriter />
    </SPageWrapper>
  )
}

const SPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 64px;

  * {
    user-select: text;
  }
`

const SDescription = styled.div`
  font-weight: 600;
  font-size: 32px;
  line-height: 32px;
  text-align: center;
  color: #000000E0;
`

const SMessageWriter = styled(AiMessageWriter)`
  margin-top: 40px;
  width: 700px;
`